var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOpenAiLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 287.636,
    height: 77.35,
    viewBox: "0 0 287.636 77.35",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OpenAI_Logo",
    transform: "translate(0 -0.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M30.6.4A30.6,30.6,0,1,0,61.2,31,30.69,30.69,0,0,0,30.6.4Zm0,50.235c-10.455,0-18.87-8.585-18.87-19.635S20.145,11.363,30.6,11.363,49.47,19.948,49.47,31,41.055,50.633,30.6,50.633Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M92.139,17.4c-5.525,0-10.88,2.21-13.685,5.95v-5.1H67.4v59.5h11.05v-21.5c2.805,3.485,7.99,5.355,13.685,5.355,11.9,0,21.25-9.35,21.25-22.1S104.039,17.4,92.139,17.4Zm-1.87,34.6c-6.29,0-11.9-4.93-11.9-12.495S83.979,27,90.269,27s11.9,4.93,11.9,12.5S96.559,51.993,90.269,51.993Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M139.4,17.4c-12.07,0-21.59,9.435-21.59,22.1s8.33,22.1,21.93,22.1c11.135,0,18.275-6.715,20.485-14.28H149.431c-1.36,3.145-5.185,5.355-9.775,5.355-5.7,0-10.03-4-11.05-9.69h32.13V38.648C160.736,27.088,152.661,17.4,139.4,17.4Zm-10.71,17.765a11.02,11.02,0,0,1,10.965-8.84c5.695,0,10.03,3.74,10.54,8.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M190.145,17.4c-4.93,0-10.115,2.21-12.5,5.865V18.248H166.6v42.5h11.05V37.883c0-6.63,3.57-10.965,9.35-10.965,5.355,0,8.245,4.08,8.245,9.775V60.748h11.05V34.908C206.295,24.368,199.835,17.4,190.145,17.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M234.6,1.25l-24.055,59.5h11.815l5.1-13.005h27.37l5.1,13.005h11.985L248.026,1.25Zm-3.315,36.635,9.86-24.9,9.775,24.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M287.636,1.25h-11.22v59.5h11.22Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOpenAiLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/OpenAI_Logo.f4b11be3eb6d29a64544684422a03ffc.svg";